import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetAnalysisSegmentDomain = (state) =>
  state.get("widgetAnalysisSegmentV2", initialState)

export const makeSelectIsLoadingRanks = () =>
  createSelector(selectWidgetAnalysisSegmentDomain, (state) =>
    state.get("isLoadingRanks")
  )

export const makeSelectRanks = () =>
  createSelector(selectWidgetAnalysisSegmentDomain, (state) =>
    state.get("ranks")
  )

const makeSelectWidgetAnalysisSegment = () =>
  createSelector(selectWidgetAnalysisSegmentDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetAnalysisSegment
export { selectWidgetAnalysisSegmentDomain }
